import React, { Component, createRef, Suspense } from 'react'

/* Socket IO */
import { io } from "socket.io-client"

/* JWT */
import { decodeToken } from 'react-jwt'

/* Constants */
import { images, env, sound, times, utils } from './constants'
import { LOADING, ERROR, CHOICE, WAITING } from './constants/status'

/* UUID */
import { v4 as uuidv4 } from 'uuid'

import { Background } from '@cuba-go/poker-ui'

// import GameControl from './components/GameControlTest'

/* Poker UI */
const Error = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.Error })))
const GameControl = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.GameControl })))
const Balance = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.Balance })))
const Internet = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.Internet })))
const GameInfo = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.GameInfo })))
const Timer = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.Timer })))
const Notification = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.Notification })))
const FloatingMessages = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.FloatingMessages })))
const InactionTiming = React.lazy(() => import('@cuba-go/poker-ui').then(mode => ({ default: mode.InactionTiming })))

/* Widgets */
const Preloader = React.lazy(() => import('./widgets/Preloader'))
const BetTable = React.lazy(() => import('./widgets/BetTable'))
const Chips = React.lazy(() => import('./widgets/Chips'))
const History = React.lazy(() => import('./widgets/History'))
const Statistics = React.lazy(() => import('./widgets/Statistics'))
const Return = React.lazy(() => import('./widgets/Return'))
const Numbers = React.lazy(() => import('./widgets/Numbers'))

/* Rules */
import { list } from './constants/rules'

/* REST API */
import { history, getLast100 } from "./api/History"
import { messages } from "./api/Support"

/* Components */
const GamePayout = React.lazy(() => import('./components/GamePayout'))
const Result = React.lazy(() => import('./components/Result'))
const GameBottomModal = React.lazy(() => import('./components/GameBottomModal'))
const Logo = React.lazy(() => import('./components/Logo'))

/* Intenet speed check url */
const imgUrl = "https://cb.cuba-lv.com/images/dealerinfo/close.png"

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""

const userAgent = navigator.userAgent;
const isIOS = /iPad|iPhone|iPod/.test(userAgent);

/* Entry Point */
class App extends Component {


    constructor() {
        super()

        const data = decodeToken(token)

        this.state = {
            /* General */
            cached: false,
            status: LOADING,
            balance: null,
            currency: (token && data && data.currency) ? data.currency : 'USD',
            identifier: (token && data && data.identifier) ? data.identifier : '1',
            lastWin: 0,
            selected: 2,

            stakes: [],
            list: [],
            last: null,
            total: 0,
            result: null,
            wheelNumber: null,
            totalWin: 0,

            stage: null,

            /* Game Info */
            max: data && data.max ? data.max : 0,
            min: data && data.min ? data.min : 0,
            maxPay: data && data.maxPay ? data.maxPay : 0,

            times: {
                choise: times.CARD_HAND_UP_TIME
            },

            gameInfo: null,
            transactions: [],
            operations: [],
            histories: [],
            historyLoading: true,
            historyPage: 1,
            historyHasMore: true,
            dealerInfo: null,

            lastNumbers: [],

            showStatistics: false,
            showReturn: false,
            activeModal: "",
            last100: [],

            /* Game Session */
            closed: false,
            newDevice: false,
            isDisconnected: false,
            isPaused: false,

            /* Other */
            chips: data && data.chips && Array.isArray(data.chips) ? data.chips : [],
            backColor: data && data.backColor ? data.backColor : "",
            gameImg: data && data.gameImg ? `${env.mediapoint}/images/table-images/` + data.gameImg : null,

        }

        this.notifyRef = React.createRef()

        /* Start connection */
        this.socket = io(env.endpoint, { auth: { token: `${token}`, reconnection: false, isPlayer: true } })

        /* Timing ref */
        this._balanceErrorTiming = null
        this._maxBetErrorTiming = null

        /* Backfround ref */
        this._background = createRef(null)

    }

    componentDidMount = () => {
        this.game()
        this.cache()
        this.loadSupportMessages()

        const isRuleOpened = localStorage.getItem('isRuleOpened')

        if (!isRuleOpened && env.type === "super-roulette") {
            setTimeout(() => {
                this.setState({ showReturn: true })
            }, 1000)
            localStorage.setItem("isRuleOpened", 'true')
        }
    }

    /* Load History */
    loadHistory = (page = 1) => {

        const { histories } = this.state

        /* Until the first reconnection the table is unknown — the history would come for all tables */
        if (!this._historyLoaded) {
            return
        }

        if (page > 0) {
            this.setState({ historyPage: page })
        }

        history(token, page, this._table).then(response => {
            if (response.status === 200) {

                const data = response.data

                let list = data.list

                if (page > 1) {
                    list = [...histories, ...data.list]
                }

                if (data.list.length < 10) {
                    this.setState({ historyHasMore: false })
                }

                this.setState({ histories: list, historyLoading: false, lastNumbers: data.last ? data.last : [] })
            }
        }).catch(() => {
            this.setState({ histories: [], historyLoading: false })
        })
    }

    /* The last 100 numbers of this table */
    loadLast100 = table => {
        getLast100(token, table).then(response => {
            if (response.status === 200) {
                this.setState({ last100: response.data })
            }
        }).catch(() => {
        })
    }

    /* Load Support Messages */
    loadSupportMessages = () => {
        messages(token).then(response => {
            if (response.status === 200) {

                /* Create Timer */
                const timer = setTimeout(() => {

                    /* Set Support Messages */
                    if (this._background && this._background.current) {
                        this._background.current.setSupportMessage(response.data)
                    }

                    /* Clear Timer */
                    clearTimeout(timer)

                }, 2100)

            }
        })
    }

    /* Send Message */
    sendMessage = message => {
        this.socket.emit("messageFromPlayer", message.message)
        if (this._floatingMessages) {
            this._floatingMessages.sendMessage(message)
        }
    }

    /* Send Message */
    sendSupportMessage = message => {
        this.socket.emit("supportMessage", message.message)
    }

    game = () => {
        /* On error */
        this.socket.on("connect_error", () => {

            this.clear()

            const timer = setTimeout(() => {
                this.setState({ status: ERROR })
                clearTimeout(timer)
            }, 1000)

            this.clearTiming()
        })

        /*  */
        this.socket.on("disconnect", () => {
            this.setState({ isDisconnected: true })
            this.clear()
            this.clearTiming()
        })

        /* On connect */
        this.socket.on("connect", () => {
            const timer = setTimeout(() => {
                this.setState({ status: null })
                clearTimeout(timer)
                this.resetTimer()
            }, 2000)
        })

        /* On New Device */
        this.socket.on("newDeviceConnection", () => {
            this.setState({ newDevice: true })
            this.socket.disconnect()
            this.clear()
            this.clearTiming()
        })

        /* Balance */
        this.socket.on("balance", data => {
            this.setState({ balance: data })
        })

        /* Stake */
        this.socket.on("playerStakes", data => {
            this.setState({ stakes: data, last: data })
        })

        /* Get pause command from dealer monitor */
        this.socket.on("pause", () => {
            this.setState({ isPaused: true })
            this.notify('pause', 'show')
            this.clearTiming()
        })

        /* Continue Event */
        this.socket.on("continue", () => {
            this.setState({ isPaused: false })
            this.notify('pause', 'close')
        })

        /* On start */
        this.socket.on("status", data => {
            const { status, stakes } = this.state

            if (status !== data) {
                if (data === CHOICE && status !== CHOICE) {
                    this.loadHistory(1)
                    this.clear()
                }
                if (data !== CHOICE && !(stakes && stakes.length > 0)) {
                    this.setState({ status: WAITING, list: [] })
                }
                else {
                    this.setState({ status: data, list: [] })
                }
            }
        })


        /* On close Table */
        this.socket.on("closeTable", () => {

            /* Close Notification */
            this.notify("tableClosed", "close")

            this.loadHistory(1)
            this.clear()
        })

        /* On tableCloseNext */
        this.socket.on("tableCloseNext", () => {

            /* Show Notification */
            this.notify("tableClosed", "show")

        })


        /* Get a dealer Info */
        this.socket.on("dealerInfo", data => {
            this.setState({ dealerInfo: data })
        })


        /* Reconnection */
        this.socket.on("reconnection", data => {
            if (data) {
                this.reconnectionClear()

                /* The history and the statistics are loaded for this table only — its slug comes with the first reconnection */
                if (!this._historyLoaded) {
                    this._historyLoaded = true
                    this._table = data.table
                    this.loadHistory(1)
                    this.loadLast100(data.table)
                }

                if (data.reason && data.reason === "transaction") {
                    this.notify("transaction", 'show')
                }

                const status = data.status
                const stakes = data.stakes ? data.stakes : []
                const times = data.times
                const stage = data.stage ? data.stage : null

                const isPaused = data.isPaused
                const wheelNumber = data.wheelNumber

                setTimeout(() => {

                    this.setState({ status, isPaused, wheelNumber, dealerInfo: data.dealerInfo })

                    if (isPaused) {
                        this.notify("pause", "show")
                    }

                    this.notify("pause", 'close')
                    this.notify("transaction", 'close')

                    if (stakes && Array.isArray(stakes) && stakes.length > 0) {

                        this.setState({
                            stakes,
                            result: data.result,
                            totalWin: data.totalWin,
                            last: data.last,
                            total: data.total,
                            times,
                            gameInfo: data.gameData,

                            result: data.result,
                            transactions: data.transactions

                        })
                    }

                    this.setState({
                        stage: data.stage
                    })

                    if (!isPaused) {

                        setTimeout(() => {

                            if (this._timing && times && stage && parseInt(times[stage]) > 0) {
                                this._timing.start(times[stage], stage)
                            }
                            else {
                                setTimeout(() => {
                                    if (this._timing && times && stage && parseInt(times[stage]) > 0) {
                                        this._timing.start(times[stage], stage)
                                    }
                                }, 1500)
                            }

                        }, 1000)

                    }

                }, 2000)

            }
        })

        this.socket.on("gameData", data => {
            this.setState({
                playerCards: data.playerCards,
                playerGame: data.playerGame,
                dealerCards: data.dealerCards,
                dealerGame: data.dealerGame
            })
        })

        /* Timer Stage */
        this.socket.on("stage", data => {
            const { type, times } = data

            this.setState({ stage: type, times: times })

            if (this._timing && times && parseInt(times[type]) > 0 && type) {
                this._timing.start(times[type], type)
            }

        })

        this.socket.on("winNumber", data => {
            const { number, color } = data
            this.setState({ wheelNumber: number })

            const { last100 } = this.state
            let tempLast = [...last100]
            tempLast.unshift({ number, color })
            this.setState({ last100: tempLast.slice(0, 100) })
        })

        /* Result */
        this.socket.on("result", data => {
            const { result, totalWin } = data
            this.setState({ result, totalWin })
            if (totalWin) {
                sound.play('winsmall', 0.5)
                this.setState({ lastWin: totalWin })
            }
        })

        /* Message */
        this.socket.on("message", data => {
            if (this._floatingMessages) {
                this._floatingMessages.sendMessage(data)
            }
            if (this._background && this._background.current) {
                this._background.current.addMessage(data)
            }
        })

        /* On Support Message */
        this.socket.on("adminSupportAnswer", data => {
            if (this._floatingMessages) {
                this._floatingMessages.sendMessage(data)
            }
            if (this._background && this._background.current) {
                this._background.current.addSupportMessage(data)
            }
        })

        /* Get Game Info */
        this.socket.on("gameInfo", data => {
            this.setState({ gameInfo: data })
        })

        /* Get Game Info */
        this.socket.on("refund", data => {
            this.notify("refund", "refund", { type: "refund", total: data })
            this.loadHistory(1)
        })

        /* Get transactions list */
        this.socket.on("transaction", data => {
            if (data.id) {
                const { transactions, operations } = this.state
                let list = [data, ...transactions]
                let operationsList = [data, ...operations]
                this.setState({ transactions: list, operations: operationsList })

                setTimeout(() => {
                    let operationsList = this.state.operations
                    operationsList = operationsList.filter(item => item.id !== data.id)
                    this.setState({ operations: operationsList })
                }, 3500)

            }
        })

        this.socket.on("editTransaction", data => {
            const { transactions } = this.state
            let list = transactions
            const index = list.findIndex(e => e.number === data.number)
            if (index > -1) {
                list[index].status = data.status
                this.setState({ transactions: list })
            }
        })

        this.socket.on("forceEnd", data => {
            this.forceEnd(data)
            this.loadHistory(1)
        })

        this.socket.on("reloadPage", () => {
            window.location.reload()
        })

    }



    /* Force End Action */
    forceEnd = (data) => {

        this.notify("pause", "close")

        const timer = setTimeout(() => {
            this.notify("forceEnd", "show")

            const close = setTimeout(() => {
                this.notify("forceEnd", "close")
                clearTimeout(close)
            }, 4000)

            clearTimeout(timer)
        }, 2000)

        this.setState({
            status: CHOICE,
            isPaused: false,
            stakes: [],
            list: [],
            total: 0,
            result: null,
            wheelNumber: null,
            totalWin: 0,

            stage: null,
            times: {
                choise: times.CARD_HAND_UP_TIME,
            },

            gameInfo: null,
            transactions: [],
            operations: [],
        })

        if (data && data.refund) {
            this.notify("refund", "refund", { type: "refund", total: parseFloat(data.refund) })
        }
    }

    /* Clear timing to remove sound */
    clearTiming = () => {
        if (this._timing) {
            this._timing.clear()
        }
        setTimeout(() => {
            if (this._timing) {
                this._timing.clear()
            }
        }, 1500)
    }

    reconnectionClear = () => {
        this.setState({
            stakes: [],
            total: 0,
            result: null,
            wheelNumber: null,
            totalWin: null,

            stage: null,

            gameInfo: null,
            transactions: [],
        })
    }

    /* Show and close notifications */
    notify = (type, action, data = null) => {

        const notifyData = { type, action, data }

        if (this._notify) {
            this.notifyAction(notifyData)
        }
        else {
            setTimeout(() => {
                if (this._notify) {
                    this.notifyAction(notifyData)
                }
            }, 2000)
        }

    }

    /* Do notify actions after notify component check */
    notifyAction = (notifyData) => {

        const { type, action, data = null } = notifyData
        if (action === "show") {
            this._notify.show(type)
        }
        else if (action === 'close') {
            this._notify.close(type)
        }
        else if (action === 'refund') {
            if (data.total) {
                const title = data.type === 'refund' ? 'Возврат средств' : "Пополнение суммы"
                const uid = uuidv4()
                this._notify.refund({ title, total: data.total, uid })
            }
        }

    }

    /* Check internet speed */
    checkInternetSpeed = (speed) => {
        if (parseInt(speed) < 5) {
            this.notify('internet', 'show')
        }
        else {
            this.notify('internet', 'close')
        }
    }

    /* Cache images */
    cache = async () => {

        const promises = images.data.map(uri => {

            return new Promise(function (resolve, reject) {
                const img = new Image()
                img.src = uri
                img.onload = resolve()
                img.onerror = reject()
            })

        })

        await Promise.all(promises)

        this.setState({ cached: true })
    }

    /* Reser top timing */
    resetTimer = () => {
        if (this._inaction) {
            this._inaction.reset()
        }
    }

    /* Disconnect user when inaction timer equal to 0 */
    setInactionState = () => {
        this.setState({ closed: true })
        this.socket.disconnect()
        this.clear()
    }


    /* Toggle Balance Error */
    toggleBalanceError = () => {

        sound.play("blocked", 0.6)

        if (!this._balanceErrorTiming) {
            this.notify('balanceError', 'show')
        }

        if (this._balanceErrorTiming) {
            clearTimeout(this._balanceErrorTiming)
            this._balanceErrorTiming = null
        }

        this._balanceErrorTiming = setTimeout(() => {
            this.notify('balanceError', 'close')
            clearTimeout(this._balanceErrorTiming)
            this._balanceErrorTiming = null
        }, 2000)

    }

    /* Toggle Balance Error */
    toggleMaxBetError = () => {

        sound.play("blocked", 0.6)

        if (!this._maxBetErrorTiming) {
            this.notify('maxBetError', 'show')
        }

        if (this._maxBetErrorTiming) {
            clearTimeout(this._maxBetErrorTiming)
            this._maxBetErrorTiming = null
        }

        this._maxBetErrorTiming = setTimeout(() => {
            this.notify('maxBetError', 'close')
            clearTimeout(this._maxBetErrorTiming)
            this._maxBetErrorTiming = null
        }, 2000)

    }


    /* Set ante value */
    setStakes = (data) => {

        const newTotal = data.reduce((sum, item) => sum + item.value, 0)
        const delta = newTotal - this.state.total
        this.setState({ stakes: data, total: newTotal, lastWin: 0, balance: this.state.balance - delta })
        this.socket.emit("stakes", data)

        sound.play('sound')
        this.resetTimer()
    }

    /* Clear all variables */
    clear = () => {
        this.setState({
            stakes: [],
            total: 0,
            result: null,
            wheelNumber: null,
            totalWin: 0,

            stage: null,

            gameInfo: null,
            transactions: [],
        })
    }

    /* DRAW CHIPS */
    renderChips = () => {

        const { stakes, chips, last, selected, list, balance, max, currency, volume } = this.state

        return (
            <Chips
                chips={chips}
                stakes={stakes}
                last={last}
                selected={selected}
                list={list}
                balance={balance}
                currency={currency}
                volume={volume}
                max={max}
                setStakes={data => this.setStakes(data)}
                setSelected={selected => this.setState({ selected })}
                setList={data => this.setState({ list: data })}
                toggleBalanceError={() => this.toggleBalanceError()}
                toggleMaxBetError={() => this.toggleMaxBetError()}
            />
        )

    }

    content = () => {

        const { status, stakes, selected, chips, list, max, min, wheelNumber, totalWin, result, currency, total, balance, lastNumbers, last100, showStatistics, showReturn } = this.state

        return (
            <div className='app-content'>
                <Numbers lastNumbers={lastNumbers} />
                {wheelNumber !== null ? <Result wheelNumber={wheelNumber} totalWin={totalWin} currency={currency} /> : null}
                <div className={`app-content-inner ${isIOS ? "ios" : ""}`}>
                    <BetTable
                        status={status}
                        stakes={stakes}
                        selected={selected}
                        chips={chips}
                        list={list}
                        setList={list => this.setState({ list })}
                        max={max}
                        min={min}
                        result={result}
                        wheelNumber={wheelNumber}
                        setStakes={data => this.setStakes(data)}
                        renderChips={() => this.renderChips()}
                        total={total}
                        balance={balance}
                        toggleBalanceError={() => this.toggleBalanceError()}
                        toggleMaxBetError={() => this.toggleMaxBetError()}
                        currency={currency}
                        lastNumbers={lastNumbers}
                        last100={last100}
                        showStatistics={showStatistics}
                        setShowStatistics={value => this.setState({ showStatistics: value, activeModal: value ? "statistics" : "return" })}
                        showReturn={showReturn}
                        setShowReturn={value => this.setState({ showReturn: value, activeModal: value ? "return" : "statistics" })}
                    />
                </div>
            </div>
        )

    }

    render = () => {

        const { status, cached, dealerInfo, currency, total, balance, lastWin, transactions, gameInfo, operations, histories, historyPage, historyHasMore, closed, newDevice, max, min, maxPay, isDisconnected, isPaused, identifier, backColor, gameImg, showStatistics, showReturn, last100, activeModal } = this.state

        const nextGame = status === WAITING

        const style = (nextGame || newDevice || closed || isDisconnected) ? "hidden" : ""

        const gamePayout = <GamePayout currency={currency} max={max} min={min} />

        let content = (
            <Background token={token} gameType="roulette" ref={this._background} gamePlace={env.gamePlace} historyComponent={History}
                currency={currency} maxPay={maxPay} status={status} dealer={dealerInfo} sendMessage={message => this.sendMessage(message)} sendSupportMessage={message => this.sendSupportMessage(message)} info={gameInfo} transactions={transactions} histories={histories} loadMore={() => this.loadHistory(historyPage + 1)} historyHasMore={historyHasMore} identifier={identifier} rules={list} gamePayout={gamePayout} videoBackImg={gameImg} textileColor={backColor}>
                <Timer roulette={true} key="timing" ref={ref => this._timing = ref} style={style} isPaused={isPaused} />
                <InactionTiming time={300} ref={ref => this._inaction = ref} status={status} isPaused={isPaused} setInactionState={() => this.setInactionState()} />
                <GameInfo currency={currency} info={gameInfo} operations={operations} />
                <GameControl title={env.name} maxPay={0} max={max} min={min} currency={currency} info={gameInfo} data={dealerInfo} gamePayout={gamePayout} onQuitGame={() => this.quitGame()} />
                <Balance balance={balance} total={total} lastWin={lastWin} currency={currency} />
                <FloatingMessages ref={ref => this._floatingMessages = ref} />

                {/* Roulette logo */}
                <Logo />

                {this.content()}

                <Notification nextGame={nextGame} ref={ref => this._notify = ref} currency={currency} max={max} roulette={true} />

                <Internet url={imgUrl} setInternetSpeed={data => this.checkInternetSpeed(data)} />
                <GameBottomModal visible={showStatistics} style={{ zIndex: activeModal === "statistics" ? 11 : 10 }}>
                    <Statistics last100={last100} close={() => this.setState({ showStatistics: false })} />
                </GameBottomModal>
                <GameBottomModal visible={showReturn} style={{ zIndex: activeModal === "return" ? 11 : 10 }}>
                    <Return close={() => this.setState({ showReturn: false })} />
                </GameBottomModal>
            </Background>

        )

        if (status === ERROR || newDevice || closed || isDisconnected) {
            content = (
                <Suspense>
                    <Error newDevice={newDevice} closed={closed} isDisconnected={isDisconnected} />
                </Suspense>
            )
        }

        if (status === LOADING || !cached) {
            content = (
                <Suspense>
                    <Preloader url={gameImg} />
                </Suspense>
            )
        }

        return content
    }

}

export default App